// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"cp-z","imageAndVideoCount":"dp-z","imageAndVideoContainer":"ep-z","viewAllReviews":"fp-z"};